exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._5Tcd_{float:left;margin-right:32px;margin-right:2rem;margin-bottom:32px;margin-bottom:2rem}._5Tcd_+p{margin-top:0}._1Xszr{max-width:140px;-webkit-box-shadow:3px 3px 8px rgba(0,0,0,.25);box-shadow:3px 3px 8px rgba(0,0,0,.25);image-rendering:-webkit-optimize-contrast}.yEtXj{margin-top:5px}", ""]);

// exports
exports.locals = {
	"root": "_5Tcd_",
	"image": "_1Xszr",
	"mt0": "yEtXj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Fact/FactImageThumbnail.css
// module id = 678
// module chunks = 0 1